import axios from "axios";
import React from "react";

import { APIEndpoints } from "@/apis/endpoints";
import TrashIconButton from "@/components/buttons/TrashIconButton";
import { extractErrorMessage } from "@/utils/misc";

export function Delete({ tooltip, department, departments, setDepartments }) {
  const onDeleteClick = async () => {
    const departmentIdToDelete = department.id;

    try {
      await axios.delete(APIEndpoints.SIMULATION + "/departments", {
        data: { id: department.id, name: department.name },
      });
      setDepartments(departments.filter((d) => d.id !== departmentIdToDelete));
    } catch (error) {
      alert(extractErrorMessage(error));
    }
  };
  return <TrashIconButton onClick={onDeleteClick} title={tooltip} />;
}
